import { PermissionArea } from '../auth/permission.service';

export interface NavArea {
  readonly id: string; // 'cmt' | 'brandManager' | 'callViewer'
  readonly label: string; // full name — tooltip + aria-label
  readonly shortLabel: string; // compact label shown under the icon (fits the slim rail)
  readonly icon: string; // lucide name, already in ALL_ICONS
  readonly route: string; // navigateByUrl target
  readonly matchPrefixes: readonly string[]; // URL prefixes marking this area active
  readonly isDefault?: boolean; // fallback area when no prefix matches
  readonly permissionKey?: PermissionArea; // omitted = always visible
}

export const NAV_AREAS: readonly NavArea[] = [
  { id: 'cmt', label: 'Customer Management Tool', shortLabel: 'CMT', icon: 'lucideUsers', route: '/', matchPrefixes: [], isDefault: true },
  { id: 'brandManager', label: 'Brand Manager', shortLabel: 'Brands', icon: 'lucideBuilding2', route: '/admin', matchPrefixes: ['/admin'], permissionKey: 'brandManager' },
  { id: 'callViewer', label: 'Call Viewer', shortLabel: 'Calls', icon: 'lucidePhone', route: '/calls', matchPrefixes: ['/calls'] },
];

// First non-default area whose prefix matches the PATH (query + fragment stripped);
// else the isDefault area. Boundary-safe: '/callsfoo' must NOT match '/calls'.
export function resolveActiveAreaId(url: string): string {
  const path = url.split(/[?#;]/)[0];
  const match = NAV_AREAS.find((a) =>
    a.matchPrefixes.some((p) => path === p || path.startsWith(p + '/')),
  );
  return (match ?? NAV_AREAS.find((a) => a.isDefault))!.id;
}
